<template>
   <v-stepper v-model="currentStep" vertical>
    <v-stepper-step step="1">
      Dados da importação
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-form v-model="valid" @submit.prevent="submit" ref="form">
        <v-text-field
          v-model="name"
          :rules="nameRules"
          type="name"
          :counter="250"
          label="Nome da importação"
          placeholder="Utilizado para adicionar tags de identificação aos leads importados"
          required
        >
        </v-text-field>
        <p>Os leads serão marcados com a tag: {{formatedTag}}</p>
      </v-form>
      <v-btn color="primary" :disabled="!valid" @click="currentStep = 2">Continuar</v-btn>
    </v-stepper-content>

    <v-stepper-step step="2">Enviar arquivo</v-stepper-step>

    <v-stepper-content step="2">
      <file-pond
        name="sheet"
        ref="pond"
        label-idle="Solte um arquivo aqui"
        labelFileProcessing="Enviando..."
        labelFileProcessingComplete="Arquivo enviado"
        labelFileProcessingAborted="Envio cancelado"
        labelFileProcessingError="Falha ao enviar"
        labelButtonAbortItemLoad="Abortar"
        labelButtonRetryItemLoad="Tentar novamente"
        labelButtonAbortItemProcessing="Cancelar"
        :allow-multiple="false"
        accepted-file-types="text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :server="server"
        v-bind:files="myFiles"
        v-on:init="handleFilePondInit"
        v-on:processfile="handleFileFinished"
        />
        <v-btn @click="$emit('closeDialog')">Cancelar</v-btn>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
  import vueFilePond from 'vue-filepond';
  import 'filepond/dist/filepond.min.css';  
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';

  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileMetadata);  
  export default {

    name: 'Import',
    components: {
      FilePond
    },
    methods: {
      handleFilePondInit: function() {
        console.log('FilePond has initialized');

          // FilePond instance methods are available on `this.$refs.pond`
      },
      handleFileFinished() {
        this.$emit('closeDialog');
        this.$store.dispatch('fetchLeads');
      },
    },
    computed: {
      formatedTag() {
        return this.name.toLowerCase().replace(/\s+/g, '_');
      },
      server() {
        return {
          url: process.env.VUE_APP_API_BASE_URL,
          process: {
            url: `/api/leads/import/${this.formatedTag}`,
            method: 'POST',
            withCredentials: false,
            headers: {
              Accept: 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            },
            timeout: 7000,
            onload: null,
            onerror: null,
            ondata: null
          }
        }
      }
    },
    data () {
      return {
        myFiles: [],
        currentStep: 1,
        valid: false,
        name: '',
        nameRules: [
          v => !!v || 'Insira o nome da importação',
          v => v && v.length <= 250 || 'O nome da importação deve ter no máximo 250 caracteres',
        ],
      }
    }
  }
  </script>

  <style lang="css" scoped>
</style>